export const useNewApi = () => {
  const app = useAppStore()

  const translatePassage = async (data: { UM_ID: string; PASSAGE: string }) => {
    // 환경 변수 확인
    const env = import.meta.env.VITE_ENV
    const isDevelopment = env === 'DEV' || env === 'LOCAL'

    return await $fetch(
      'https://4ifvwybgcwscbnpnkxwl7afup40hqapn.lambda-url.ap-northeast-2.on.aws',
      {
        method: 'POST',
        body: {
          STAGE: isDevelopment ? 'dev' : 'prod', // STAGE 파라미터 추가
          ...data, // 기존 UM_ID, PASSAGE 유지
        },
        headers: {
          Authorization: `Bearer ${app.user?.JADOO_TOKEN}`,
          'Content-Type': 'application/json',
        },
      },
    )
  }

  return { translatePassage }
}
